import React from 'react';
import { useNavigate } from 'react-router-dom';

export function ProductRecommendations({ recommendations }) {
  const navigate = useNavigate();
  if (!recommendations.length) return null;

  return (
    <div className="border-t border-[#E5E5E5] mt-4 pb-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-14">
        <div className="flex items-center justify-between mb-8">
          <h2 className="font-playfair text-2xl text-[#0A0A0A] tracking-tight" data-testid="recommendations-heading">
            You May Also Like
          </h2>
          <div className="h-px flex-1 bg-[#E5E5E5] ml-8" />
        </div>
        <div className="flex gap-5 overflow-x-auto pb-2 scrollbar-hide" data-testid="recommendations-strip">
          {recommendations.map(p => (
            <div
              key={p.product_id}
              className="flex-shrink-0 w-44 sm:w-52 group cursor-pointer"
              onClick={() => navigate(`/product/${p.product_id}`)}
              data-testid={`reco-card-${p.product_id}`}
            >
              <div className="w-full aspect-[3/4] bg-[#F9F9F9] overflow-hidden mb-3 relative">
                <img
                  src={p.images?.[0]}
                  alt={p.name}
                  className="object-cover w-full h-full group-hover:scale-105 transition-transform duration-500"
                />
                {p.rec_reason && (
                  <span className="absolute bottom-2 left-2 bg-white/90 backdrop-blur-sm text-[9px] uppercase tracking-wider font-work text-[#555555] px-2 py-1">
                    {p.rec_reason}
                  </span>
                )}
              </div>
              <p className="text-[10px] uppercase tracking-wider text-[#D4AF37] font-work mb-0.5">{p.designer}</p>
              <p className="text-xs text-[#0A0A0A] font-work leading-tight mb-1 line-clamp-2">{p.name}</p>
              <p className="text-sm font-semibold text-[#0A0A0A] font-work">
                {`R${Number(p.final_price).toLocaleString('en-ZA')}`}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
